import api from '@services/api';
import { ClientInput, RuleClientPriority, SearchClientInput } from '../models/client';

/**
 * <p>
 * API endpoints that cover all Rule Client Priority related CRUD calls
 */

export const clientPriorityApi = api.injectEndpoints({
  endpoints: (builder) => ({
    searchClientPriority: builder.query<RuleClientPriority[], SearchClientInput>({
      query: (input: SearchClientInput) => ({
        url: encodeURI(`indirect/rule-client-priority/searchBy?searchTerm=${input.searchTerm}`),
      }),
      providesTags: ['ClientPriority'],
    }),
    removeClientPriority: builder.mutation<void, number>({
      query: (id) => ({
        url: `/indirect/rule-client-priority/delete?id=${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['ClientPriority'],
    }),
    createOrUpdateClientPriority: builder.mutation<void, ClientInput>({
      query: (dashboard) => ({
        url: '/indirect/rule-client-priority/create',
        method: 'POST',
        body: dashboard,
      }),
      invalidatesTags: ['ClientPriority'],
    }),
  }),
});

export const {
  useSearchClientPriorityQuery,
  useCreateOrUpdateClientPriorityMutation,
  useRemoveClientPriorityMutation,
} = clientPriorityApi;
